import classNames from "classnames";
import React from "react";

function StepContentItem({item, size, isSelected, onSelect}) {
    return (<div
        className={classNames("column is-flex dg-calc-item", size, {
            "is-selected": !!isSelected
        })}
        onClick={onSelect}
    >
        <div className="card">
            <div className="card-image">
                <figure className="image is-square">
                    <img src={item.img} alt={item.name}/>
                </figure>
            </div>
            <div className="card-content">
                <div className="media">
                    <div className="media-content">
                        <p className="title is-4">{item.name}</p>
                        <p className="subtitle is-6">{item.desc}</p>
                    </div>
                </div>
                {item.width ? <div className="content">
                    <div className="columns">
                        <div className="column is-half is-heading-text">
                            <p>ширина {item.width}мм.</p>
                        </div>
                        <div className="column is-half is-heading-text">
                            {item.depth ? <p>глубина {item.depth}мм.</p> : null}
                        </div>
                    </div>
                </div> : null}
            </div>
        </div>
    </div>);
}

export function StepContent({values, size, selectedItem, onSelect}) {
    return (<div className="clc-step-list">
        <div className="clc-step-wrapper">
            <div className="columns is-multiline clc-step-item clc-step-active">
                {values ? values.map((item, index) => <StepContentItem
                    key={item.name}
                    size={size}
                    item={item}
                    isSelected={selectedItem ? (selectedItem.name === item.name) : false}
                    onSelect={() => onSelect((!selectedItem || (selectedItem.name !== item.name)) ? item : null, index)}
                />) : null}
            </div>
        </div>
    </div>);
}